import axios from "axios";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { ServiceUrl } from "../../../utils/serviceUrl";

const AdmissionModel = () => {
  const [showModal, setShowModal] = useState(false);
  const [datalist, setDataList] = useState([]);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setLoader(true);
    const form = new FormData();
    form.append("show_on_website", 1);
    axios.post(ServiceUrl.DEPARTMENTS, form).then((res) => {
      if (res["data"].status == "1") {
        setDataList(res["data"].data);
      }
      setLoader(false);
    });
  };

  const admissionLink = "https://dbcmaram.kalvisalai.in/#/admission-enquiry/";

  return (
    <>
      <Modal show={showModal} size="lg" onHide={() => setShowModal(false)}>
        <Modal.Body className="text-center">
          <a
            className="modal_custom_close_icon_ps"
            onClick={() => setShowModal(false)}
          >
            x
          </a>
          <a href={admissionLink} target="_blank" rel="noopener noreferrer">
            <div className="admission-content">
              <div className="row">
                <div className="col-12 mb-3">
                  <img
                    src="https://dbcmaram.kalvisalai.in/api//public/dbcweblogo.png"
                    alt=""
                    style={{ width: "100%", maxWidth: "700px" }}
                  />
                </div>

                <div className="col-12 my-4">
                  <h6
                    className="text-uppercase text-theme fw-bolder heading-with-underline pb-1"
                    style={{ fontSize: "25px" }}
                  >
                    Pre Admission 2025-2026 Courses
                  </h6>
                </div>

                <div className="col-12">
                  {loader ? (
                    <p>Loading departments...</p>
                  ) : (
                    <div className="d-flex flex-wrap justify-content-center gap-1 mt-3">
                      {datalist.map((dept, index) => (
                        <p
                          key={index}
                          className="theme-outline d-flex align-items-center fw-bolder shadow"
                          style={{ fontSize: "12px" }}
                        >
                          {dept.department}
                        </p>
                      ))}
                    </div>
                  )}
                </div>

                <div className="col-12 text-center">
                  <p className="mt-4">
                    <a
                      href={admissionLink}
                      target="_blank"
                      className="apply-btn"
                    >
                      Apply Now
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </a>
        </Modal.Body>
      </Modal>

      <div
        className="admission-enquiry-button"
        onClick={() => setShowModal(true)}
        style={{ cursor: "pointer" }}
      >
        Admission Enquiry
      </div>
    </>
  );
};

export default AdmissionModel;
